import { CheckCircle2, Circle, Flame } from "lucide-react";
import { NETWORKS } from "../../../lib/share";

const DAY = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
const today = () => new Date().toISOString().slice(0, 10);

/** Paso 4 · plan semanal sugerido con racha. */
export const WeekPlan = ({ week, streak, materials, onShare, onToggle }) => (
  <div className="rounded-[1.5rem] border border-ink/10 bg-white p-5" data-testid="week-plan">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="text-sm text-ink/70">Una publicación al día en tus redes conectadas. Toca "Compartir" y se marca sola como publicada.</p>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-sun/30 px-3 py-1 text-xs font-bold" data-testid="streak-badge"><Flame className="h-4 w-4 text-coral" /> Racha: {streak} día{streak === 1 ? "" : "s"}</span>
    </div>
    <ol className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-7">
      {week.map((p, i) => {
        const net = NETWORKS.find((n) => n.id === p.network) || NETWORKS[0];
        const done = p.status === "publicado";
        const isToday = p.date === today();
        const material = materials.find((m) => m.slug === p.slug);
        return (
          <li key={p.id} className={`flex flex-col rounded-2xl border p-3 ${done ? "border-leaf bg-leaf/10" : isToday ? "border-ink bg-paper" : "border-ink/10"}`} data-testid={`plan-day-${i}`}>
            <div className="flex items-center justify-between">
              <span className="font-mono text-[11px] font-semibold uppercase text-ink/60">{DAY[new Date(`${p.date}T12:00:00Z`).getUTCDay() === 0 ? 6 : new Date(`${p.date}T12:00:00Z`).getUTCDay() - 1]} {p.date.slice(8)}</span>
              <button type="button" onClick={() => onToggle(p)} aria-label="Marcar" data-testid={`plan-toggle-${i}`}>{done ? <CheckCircle2 className="h-5 w-5 text-leaf-deep" /> : <Circle className="h-5 w-5 text-ink/30" />}</button>
            </div>
            <span className="mt-2 inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold" style={{ background: net.color, color: net.text }}><net.Icon className="h-3 w-3" /> {net.label}</span>
            <p className="mt-2 flex-1 text-xs font-semibold leading-tight">{p.title}</p>
            {!done && material && <button type="button" onClick={() => onShare(material, p)} className="mt-2 rounded-full bg-ink px-3 py-1.5 text-[11px] font-semibold text-white" data-testid={`plan-share-${i}`}>Compartir</button>}
            {done && <p className="mt-2 text-[11px] font-semibold text-leaf-deep">Publicado</p>}
          </li>
        );
      })}
    </ol>
  </div>
);
